import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var FileCode02 = function FileCode02(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props, {
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillOpacity: 0.01,
      d: "M8.35 14.25 10.6 12 8.35 9.75m-3.6 0L2.5 12l2.25 2.25"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M4.75 17.85c0 .418 0 .627.0231.8024a2.7 2.7 0 0 0 2.3245 2.3245C7.273 21 7.482 21 7.9 21h6.93c1.5121 0 2.2682 0 2.8458-.2943a2.6996 2.6996 0 0 0 1.1799-1.1799c.2943-.5776.2943-1.3337.2943-2.8458v-6.4906c0-.6604 0-.9906-.0746-1.3013a2.6973 2.6973 0 0 0-.3233-.7805c-.1669-.2724-.4004-.506-.8674-.9729l-2.8694-2.8694c-.467-.467-.7005-.7005-.9729-.8674a2.7005 2.7005 0 0 0-.7805-.3233C12.9512 3 12.621 3 11.9606 3H7.9c-.418 0-.627 0-.8024.0231A2.7 2.7 0 0 0 4.773 5.3476c-.023.1754-.023.3844-.023.8024m3.6 8.1L10.6 12 8.35 9.75m-3.6 0L2.5 12l2.25 2.25"
    })]
  }));
};
export default FileCode02;